<template>
  <div class="">
    <edit-mandate-codes> </edit-mandate-codes>
  </div>
</template>

<script>
import EditMandateCodes from "@/components/profile/companies-products/mandate-codes/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditMandateCodes,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Mandati",
        path: "module.PROF",
        tab: "MandateCodes",
        level: 3,
      });
      bcs.push({
        text: "Modifica Mandato",
        path: "mandate_codes.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Mandati",
        path: "module.PROF",
        tab: "MandateCodes",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Mandato",
        path: "mandate_codes.edit",
        level: 4,
      });
    }
  },
};
</script>
